import WMSCapabilities from 'ol/format/WMSCapabilities.js';
import WFSCapabilities from 'ol-wfs-capabilities';

export default class ProductDataProvider {

    static wms_parser = new WMSCapabilities();
    static wfs_parser = new WFSCapabilities();
    static dom_parser = new window.DOMParser();

	constructor() {
		
	}
	
	retrieveGetParams(search) {
	    var get_params = {};
	    if(search.length > 0 && search.startsWith("?")) {
	        var withoutId = search.match("[^#]*(?=#)?");
	        withoutId = withoutId && withoutId.length > 0 ? withoutId[0] : null;
	        
	        if(withoutId) {
	        	var pairs = withoutId.substring(1).split("&");
	        	for(var i = 0; i < pairs.length; ++i) {
	        		var segments = pairs[i].split("=");
	    			if(segments.length == 2) {
	        			get_params[segments[0]] = decodeURIComponent(segments[1]);
	        		}
	        	}
	    	}
	    }
	        
		return get_params;
	}
	
	insert(product_sheet_url) {
		console.log("insert");
		fetch(product_sheet_url)
		.then(function (response) {
			return response.json();
		})
		.then((function (product_sheet) {
			this.product_sheet = product_sheet;
			if("metadata" in product_sheet && "csw_ResourceIdentifier" in product_sheet.metadata) {
				this.insertInfo(product_sheet.metadata.csw_ResourceIdentifier);
				this.insertServices(product_sheet.metadata.csw_ResourceIdentifier);
			}
		}).bind(this));
	}
	
	insertInfo(csw_ResourceIdentifier) {
		var url = `https://vocabulary.geoportal.rlp.de/geonetwork/srv/ger/csw?service=CSW&version=2.0.2&request=GetRecords&namespace=xmlns(csw=http://www.opengis.net/cat/csw/2.0.2),xmlns(gmd=http://www.isotc211.org/2005/gmd)&resultType=results&outputFormat=application/xml%20&outputSchema=http://www.isotc211.org/2005/gmd%20&startPosition=1&maxRecords=20%20&typeNames=csw:Record%20&elementSetName=full&constraintLanguage=CQL_TEXT%20&constraint_language_version=1.1.0%20&constraint=csw:ResourceIdentifier=%27${csw_ResourceIdentifier}%27`;
		
		fetch(url)
        .then(function (response) {
            return response.text();
        })
        .then(function (text) {
            var resourceIdentifier = (new window.DOMParser()).parseFromString(text, "text/xml");
            var cswSearchResults = resourceIdentifier.getElementsByTagName("csw:SearchResults");
            cswSearchResults = cswSearchResults && cswSearchResults.length == 1 ? cswSearchResults[0] : null;
            var md_metadata = cswSearchResults.children[0].tagName == "gmd:MD_Metadata" ? cswSearchResults.children[0] : null;


            if(md_metadata) {
                var md_scopecode = md_metadata.getElementsByTagName("gmd:hierarchyLevel");
                md_scopecode = md_scopecode && md_scopecode.length == 1 ? md_scopecode[0].getElementsByTagName("gmd:MD_ScopeCode") : null;
                md_scopecode = md_scopecode && md_scopecode.length == 1 ? md_scopecode[0].textContent : null;

                var gmd_language = md_metadata.getElementsByTagName("gmd:language");
                gmd_language = gmd_language && gmd_language.length == 1 ? gmd_language[0].getElementsByTagName("gmd:LanguageCode") : null;
                gmd_language = gmd_language && gmd_language.length == 1 ? gmd_language[0].textContent : null;

                var identificationInfo = md_metadata.getElementsByTagName("gmd:identificationInfo");
                identificationInfo = identificationInfo && identificationInfo.length == 1? identificationInfo[0] : null;

                if(identificationInfo) {
                    let title = identificationInfo.getElementsByTagName("gmd:title");
                    title = title && title.length > 0 ? title[0].getElementsByTagName("gco:CharacterString") : null;
                    title = title && title.length == 1 ? title[0].textContent : null;

                    let abstract = identificationInfo.getElementsByTagName("gmd:abstract");
                    abstract = abstract && abstract.length > 0 ? abstract[0].getElementsByTagName("gco:CharacterString") : null;
                    abstract = abstract && abstract.length == 1 ? abstract[0].textContent : null;

                    var md_browseGraphic = identificationInfo.getElementsByTagName("gmd:MD_BrowseGraphic");
                    md_browseGraphic = md_browseGraphic && md_browseGraphic.length == 1 ? md_browseGraphic[0].getElementsByTagName("gmd:fileName") : null;
                    md_browseGraphic = md_browseGraphic && md_browseGraphic.length == 1 ? md_browseGraphic[0].getElementsByTagName("gco:CharacterString") : null;
                    md_browseGraphic = md_browseGraphic && md_browseGraphic.length == 1 ? md_browseGraphic[0].textContent.replace("http:", "https:") : null;

					if(md_browseGraphic) {
						var image_url = md_browseGraphic.replace("http:", "https:");
						let hvd_product_image = document.getElementById("hvd_product_image");
						hvd_product_image.className = "ce_image block";
						let imgs = hvd_product_image.getElementsByTagName("img");
						let sources = hvd_product_image.getElementsByTagName("source");
						
						for(let i = 0; i < imgs.length; ++i) {
							imgs[i].src = image_url;
							let srcset = imgs[i].srcset.split(" ");
							srcset[0] = image_url;
							imgs[i].srcset = srcset.join(" ");
						}
						for(let i = 0; i < sources.length; ++i) {
							let srcset = sources[i].srcset.split(" ");
							srcset[0] = image_url;
							sources[i].srcset = srcset.join(" ");
						}
					}
					
					if(abstract)
						document.getElementById("hvd_product_description").innerHTML = abstract;
				}
			}
					
		});
	}
	
	insertServices(csw_ResourceIdentifier) {
		var url = `https://vocabulary.geoportal.rlp.de/geonetwork/srv/ger/csw?service=CSW&version=2.0.2&request=GetRecords&namespace=xmlns(csw=http://www.opengis.net/cat/csw/2.0.2),xmlns(gmd=http://www.isotc211.org/2005/gmd)&resultType=results&outputFormat=application/xml%20&outputSchema=http://www.isotc211.org/2005/gmd%20&startPosition=1&maxRecords=20%20&typeNames=csw:Record%20&elementSetName=full&constraintLanguage=CQL_TEXT%20&constraint_language_version=1.1.0%20&constraint=csw:OperatesOn=%27${csw_ResourceIdentifier}%27`;
		
		fetch(url)
        .then(function (response) {
            return response.text();
        })
        .then((function (text) {
            var operates_on = (new window.DOMParser()).parseFromString(text, "text/xml");
            var cswSearchResults = operates_on.getElementsByTagName("csw:SearchResults");
            cswSearchResults = cswSearchResults && cswSearchResults.length > 0 ? cswSearchResults[0] : null;

            var capabilities_url = null;

            for(let i = 0; i < cswSearchResults.children.length; ++i) {
                let md_metadata = cswSearchResults.children[i].tagName == "gmd:MD_Metadata" ? cswSearchResults.children[i] : null;
                if(md_metadata) {
                    let service_type = this.determineServiceType(md_metadata);
                    if(service_type == "wms" || service_type == "wfs") {
                        capabilities_url = md_metadata.getElementsByTagName("srv:connectPoint");
                        capabilities_url = capabilities_url && capabilities_url.length == 1 ? capabilities_url[0].getElementsByTagName("gmd:CI_OnlineResource") : null;
                        capabilities_url = capabilities_url && capabilities_url.length == 1 ? capabilities_url[0].getElementsByTagName("gmd:URL") : null;
                        capabilities_url = capabilities_url && capabilities_url.length == 1 ? capabilities_url[0].textContent : null;

                        if(capabilities_url) { 
                            if(service_type == "wms")
                                this.addWMS(capabilities_url);
                            else 
                                this.addWFS(capabilities_url);
                        }      
                    }
                    else {
                        this.addAtom(md_metadata);
                    } 
                } 
            } 
        }).bind(this)); 
	}
	
	determineServiceType(md_metadata) {

        var serviceIdentification = md_metadata.getElementsByTagName("srv:SV_ServiceIdentification");
        serviceIdentification = serviceIdentification && serviceIdentification.length == 1 ? serviceIdentification[0] : null; 

        var service_type = serviceIdentification.getElementsByTagName("srv:serviceType");
        service_type = service_type && service_type.length == 1 ? service_type[0].getElementsByTagName("gco:LocalName") : null;
        service_type = service_type && service_type.length == 1 ? service_type[0].textContent : null;

        var service_type_version = serviceIdentification.getElementsByTagName("srv:serviceTypeVersion");
        service_type_version = service_type_version && service_type_version.length == 1 ? service_type_version[0].getElementsByTagName("gco:CharacterString") : null;
        service_type_version = service_type_version && service_type_version.length == 1 ? service_type_version[0].textContent : null;

        var md_scopecode = md_metadata.getElementsByTagName("gmd:hierarchyLevel");
        md_scopecode = md_scopecode && md_scopecode.length == 1 ? md_scopecode[0].getElementsByTagName("gmd:MD_ScopeCode") : null;
        md_scopecode = md_scopecode && md_scopecode.length == 1 ? md_scopecode[0].textContent : null;

        if(md_scopecode == "service" && service_type_version) {
            if(service_type_version == "predefined ATOM")
                return "atom";
            else if(service_type_version.match("OGC:WMS") != null)
                return "wms";
            else if(service_type == "download")
                return "wfs";
        }

        return null;
    } 

    addAtom(md_metadata) {
        var serviceIdentification = md_metadata.getElementsByTagName("srv:SV_ServiceIdentification");
        serviceIdentification = serviceIdentification && serviceIdentification.length == 1 ? serviceIdentification[0] : null; 

        var citation = serviceIdentification.getElementsByTagName("gmd:citation");
        citation = citation && citation.length == 1 ? citation[0].getElementsByTagName("gco:CharacterString") : null;
        citation = citation && citation.length == 1 ? citation[0].textContent : null;
        
        var abstract = serviceIdentification.getElementsByTagName("gmd:abstract");
        abstract = abstract && abstract.length == 1 ? abstract[0].getElementsByTagName("gco:CharacterString") : null;
        abstract = abstract && abstract.length == 1 ? abstract[0].textContent : null;

        var service_url = md_metadata.getElementsByTagName("gmd:MD_DigitalTransferOptions")
        service_url = service_url && service_url.length == 1 ? service_url[0].getElementsByTagName("gmd:URL") : null;
        service_url = service_url && service_url.length == 1 ? service_url[0].textContent : null;

        var service_type = serviceIdentification.getElementsByTagName("srv:serviceType");
        service_type = service_type && service_type.length == 1 ? service_type[0].getElementsByTagName("gco:LocalName") : null;
        service_type = service_type && service_type.length == 1 ? service_type[0].textContent : null;

        var service_type_version = serviceIdentification.getElementsByTagName("srv:serviceTypeVersion");
        service_type_version = service_type_version && service_type_version.length == 1 ? service_type_version[0].getElementsByTagName("gco:CharacterString") : null;
        service_type_version = service_type_version && service_type_version.length == 1 ? service_type_version[0].textContent : null;

        var keywords = [];

        var gmd_keyword = serviceIdentification.getElementsByTagName("gmd:keyword");
        for(let i = 0; i < gmd_keyword.length; ++i) {
            let characterString = gmd_keyword[i].getElementsByTagName("gco:CharacterString");
            characterString = characterString && characterString.length == 1 ? characterString[0].textContent : null;
            if(characterString)
                keywords.push(characterString);
        }

        var legal_constraints = serviceIdentification.getElementsByTagName("gmd:MD_LegalConstraints");
        legal_constraints = legal_constraints && legal_constraints.length > 0 ? legal_constraints[0].getElementsByTagName("gmd:otherConstraints") : null;
        legal_constraints = legal_constraints && legal_constraints.length > 0 ? legal_constraints[0].textContent : null;

        var organisation_name = serviceIdentification.getElementsByTagName("gmd:organisationName");
        organisation_name = organisation_name && organisation_name.length > 0 ? organisation_name[0].getElementsByTagName("gco:CharacterString") : null;
        organisation_name = organisation_name && organisation_name.length > 0 ? organisation_name[0].textContent : null;

        var email = serviceIdentification.getElementsByTagName("gmd:CI_Address");
        email = email && email.length > 0 ? email[0].getElementsByTagName("gmd:electronicMailAddress") : null;
        email = email && email.length > 0 ? email[0].getElementsByTagName("gco:CharacterString") : null;
        email = email && email.length > 0 ? email[0].textContent : null;

        var result = {
            "heading" : citation,
            "Dienstkennung" : {
                "Beschreibung" : abstract,
                "Dienst-URL" : `<a href="${service_url}" target="_blank">${service_url.substr(0,30)}...</a>`,
                "Typ / Version" : service_type + " (" + service_type_version + ")",
                "Stichworte" : keywords.join(", "),
                "Zugangslizenz" : legal_constraints.split(";").join("<br /><br />").replace("https://lvermgeo.rlp.de/de/geodaten/opendata/gewaehrleistung-haftung/", '<a href="https://lvermgeo.rlp.de/geodaten-geoshop/open-data/gewaehrleistung-haftung" target="_blank">Link</a>')
            },
            "Dienstanbieter" : {
                "Dienstleister" : organisation_name,
                "Kontaktdaten - E-Mail" : email
            }
        };

        this.addSection(result);
    } 

    addWFS(capabilities_url) {
        fetch(capabilities_url.replace("http:", "https:").replace(".de:80", ".de"))
        .then(function (response) {
            return response.text();
        })
        .then(function (text) {
            var wfs_result = ProductDataProvider.wfs_parser.read(text);

            var feature_types = [];
            var feature_type = null;

            for(let i = 0; i < wfs_result.FeatureTypeList.FeatureType.length; ++ i) {
                feature_type = wfs_result.FeatureTypeList.FeatureType[i];
                feature_types.push(feature_type.Title + " (" + feature_type.Name + ")");
            }

            var operations = {};

            var service_url = wfs_result.OperationsMetadata.Operation[0].DCP.HTTP.Get;
            
            for(let i = 0; i < wfs_result.OperationsMetadata.Operation.length; ++i) {
                let operation = wfs_result.OperationsMetadata.Operation[i];
                let parameters = [];
                if(operation.name == "GetFeature")
                    service_url = operation.DCP.HTTP.Get;
                for(let j = 0; j < operation.Parameter.length; ++j) {
                    let parameter = operation.Parameter[j];
                    parameters.push(parameter.name + " : <ul><li>" + parameter.Value.join("</li><li>") + "</li></ul>");
                }   
                operations[operation.name] = "<ul><li>" + parameters.join("</li><li>") + "</li></ul>";
            }

            var result = {
                "heading" : wfs_result.ServiceIdentification.Title,
                "Dienstkennung" : {
                    "Beschreibung" : wfs_result.ServiceIdentification.Abstract,
                    "Dienst-URL" : `<a href="${service_url}REQUEST=GetCapabilities&SERVICE=WFS" target="_blank">${service_url.substr(0,30)}...</a>`,
                    "Typ / Version" : wfs_result.ServiceIdentification.ServiceType + " (" + wfs_result.ServiceIdentification.ServiceTypeVersion + ")",
                    "Stichworte" : wfs_result.ServiceIdentification.Keywords.join(", "),
                    "Zugangsgebühren" : wfs_result.ServiceIdentification.Fees,
                    "Zugangslizenz" : wfs_result.ServiceIdentification.AccessConstraints.split(";").join("<br /><br />").replace("https://lvermgeo.rlp.de/de/geodaten/opendata/gewaehrleistung-haftung/", '<a href="https://lvermgeo.rlp.de/geodaten-geoshop/open-data/gewaehrleistung-haftung" target="_blank">Link</a>')
                },
                "Parameter der Anfrageformen" : operations,
                "Inhaltsmerkmale" : {
                    "Merkmalstypen" : "<ul><li>" + feature_types.join("</li><li>") + "</li></ul>"
                },
                "Dienstanbieter" : {
                    "Dienstleister" : wfs_result.ServiceProvider.ProviderName,
                    "Kontaktperson" : wfs_result.ServiceProvider.ServiceContact.IndividualName + " (" + wfs_result.ServiceProvider.ServiceContact.PositionName + ")",
                    "Kontaktdaten - Telefon" : wfs_result.ServiceProvider.ServiceContact.ContactInfo.Phone.Voice,
                    "Kontaktdaten - Fax" : wfs_result.ServiceProvider.ServiceContact.ContactInfo.Phone.Facsimile,
                    "Kontaktdaten - Adresse" : wfs_result.ServiceProvider.ServiceContact.ContactInfo.Address.DeliveryPoint + ", " + wfs_result.ServiceProvider.ServiceContact.ContactInfo.Address.PostalCode + " " + wfs_result.ServiceProvider.ServiceContact.ContactInfo.Address.City,
                    "Kontaktdaten - E-Mail" : wfs_result.ServiceProvider.ServiceContact.ContactInfo.Address.ElectronicMailAddress
                }
            };

            return result;
        }).then((this.addSection).bind(this));
    }

    addWMS(capabilities_url) {
        fetch(capabilities_url.replace("http:", "https:").replace(".de:80", ".de"))
        .then(function (response) {
            return response.text();
        })
        .then(function (text) {
            var wms_result = ProductDataProvider.wms_parser.read(text);
            var wms_dom = (new window.DOMParser()).parseFromString(text, "text/xml");
            console.log(wms_dom.querySelector("WMT_MS_Capabilities > Capability > Request > GetCapabilities > DCPType > HTTP > Get > OnlineResource"));

            var srses = []; 
            var srs_tags = wms_dom.getElementsByTagName("SRS");
            for (let i = 0; i < srs_tags.length; ++i) {
                srses.push(srs_tags[i].innerHTML);
            }

            var requests = {};
            var service_url = wms_result.Capability.Request["GetMap"]? wms_result.Capability.Request["GetMap"].DCPType[0].HTTP.Get.OnlineResource : wms_result.Service.OnlineResource;

            for(let key in wms_result.Capability.Request) {
                requests[key] = "<ul><li>" + wms_result.Capability.Request[key].Format.join("</li><li>") + "</li></ul>";
            }

            var layers = [];

            for(let i = 0; i < wms_result.Capability.Layer.Layer.length; ++i) {
                let layer = wms_result.Capability.Layer.Layer[i];
                layers.push(layer.Name);
            }

            var map_data = {
                "Titel" : wms_result.Capability.Layer.Title,
                "Beschreibung" : wms_result.Capability.Layer.Abstract,
                "Ebenen" : "<ul><li>" + layers.join("</li><li>") + "</li></ul>",
                "Koordinatensysteme" : wms_result.Capability.Layer.CRS? wms_result.Capability.Layer.CRS.join(", ") : srses.length > 0 ? srses.join(", ") : "Keine Angaben gefunden"
            };

            var result = {
                "heading" : wms_result.Service.Title,
                "Dienstkennung" : {
                    "Beschreibung" : wms_result.Service.Abstract,
                    "Dienst-URL" : `<a href="${capabilities_url}" target="_blank">${capabilities_url.substr(0,30)}...</a>`,
                    "Typ / Version" : wms_result.Service.Name + " (" + wms_result.version + ")",
                    "Stichworte" : wms_result.Service.KeywordList? wms_result.Service.KeywordList.join(", ") : wms_result.Capability.Layer.KeywordList? wms_result.Capability.Layer.KeywordList.join(", ") : "Keine Angaben gefunden.",
                    "Zugangsgebühren" : wms_result.Service.Fees,
                    "Zugangslizenz" : wms_result.Service.AccessConstraints.replace("https://lvermgeo.rlp.de/de/geodaten/opendata/gewaehrleistung-haftung/", '<a href="https://lvermgeo.rlp.de/geodaten-geoshop/open-data/gewaehrleistung-haftung" target="_blank">Link</a>')
                },
                "Formate der Anfrageformen" : requests,
                "Kartendaten" : map_data
            };

            if(wms_result.Service.ContactInformation) {
                result["Dienstanbieter"]  = {
                    "Dienstleister" : wms_result.Service.ContactInformation.ContactPersonPrimary.ContactOrganization,
                    "Kontaktperson" : wms_result.Service.ContactInformation.ContactPersonPrimary.ContactPerson + " (" + wms_result.Service.ContactInformation.ContactPosition + ")",
                    "Kontaktdaten - Telefon" : wms_result.Service.ContactInformation.ContactVoiceTelephone,
                    "Kontaktdaten - Fax" : wms_result.Service.ContactInformation.ContactFacsimileTelephone,
                    "Kontaktdaten - Adresse" : wms_result.Service.ContactInformation.ContactAddress.Address + ", " + wms_result.Service.ContactInformation.ContactAddress.PostCode + " " + wms_result.Service.ContactInformation.ContactAddress.City,
                    "Kontaktdaten - E-Mail" : wms_result.Service.ContactInformation.ContactElectronicMailAddress
                };
            } 

            return result; 
        }).then((this.addSection).bind(this));
    }
	
	addSection(content) {
		var hvd_product_services = document.getElementById("hvd_product_services");
		content = JSON.parse(JSON.stringify(content));
		var service_url = content["Dienstkennung"]["Dienst-URL"].match("(?<=^<a href=\")[^\"]+");
		service_url = service_url && service_url.length > 0 ? service_url[0] : "";

		var geoportal_link = "";
		if(service_url != "") {
			let service_search = service_url.match("\\?.*");
			service_search = service_search.length > 0 ? service_search[0] : "?";
			let service_params = this.retrieveGetParams(service_search);
			if("layer_id" in service_params && "SERVICE" in service_params) {
				geoportal_link = `<a rel="noopener" href="https://www.geoportal.rlp.de/mapbender/frames/index.php?gui_id=Geoportal-RLP_2019&WMC=15186&LAYER[id]=${service_params.layer_id}&LAYER[visible]=1&LAYER[zoom]=1" target="_blank" class="btn btn-primary">WMS im GeoPortal.rlp betrachten</a>`;
			}
		}

		delete content["Dienstkennung"]["Dienst-URL"];
		delete content["Dienstanbieter"];
		var result ={
			"URL" : `<input class="form-control" style="" type="text" value="${service_url}">
<button class="btn btn-primary" style="margin-top: 1ex;font-weight: bold;" onclick="var inputs = this.parentElement.getElementsByTagName('input'); if(inputs.length > 0) { let input = inputs[0]; input.select(); input.setSelectionRange(0,99999); navigator.clipboard.writeText(input.value); window.alert('URL kopiert.');}">kopieren</button> ${geoportal_link}`
		}
		result = Object.assign(result, content);
		if(document.getElementById("hvd_services_loading")) { 
			hvd_product_services.innerHTML = this.generateFieldsetHTML(result);
		}
		else { 
			hvd_product_services.innerHTML = hvd_product_services.innerHTML + this.generateFieldsetHTML(result);
		}
		if(location.href.endsWith("#Dienste"))
			location.href = location.href;
	}
	
	generateFieldsetHTML(data) {
		var innerHTML = [];
		if("heading" in data) {
			innerHTML.push(`<h3>${data.heading}</h3>`);
		}
		for(let key in data) {
			if(key == "heading")
				continue;
			innerHTML.push(`<fieldset style="margin-bottom: 1ex; margin-left: 1ex;">`);
			innerHTML.push(`<legend>${key}</legend>`);
			if(typeof(data[key]) == "object") {
				innerHTML.push("<table>")
				for(let subkey in data[key]) {
					innerHTML.push("<tr>");
					innerHTML.push(`<th style="padding-right: 1ex; width: 12em">${subkey}</th>`);
        
					if(typeof(data[key][subkey]) == "object") {
						innerHTML.push(`<td>${JSON.stringify(data[key][subkey])}</td>`);
					}
					else {
						innerHTML.push(`<td>${data[key][subkey]}</td>`);
					}
					innerHTML.push("</tr>");
				}
				innerHTML.push("</table>");
			}
			else {
				innerHTML.push(`<p>${data[key]}</p>`);
			}
		innerHTML.push("</fieldset>")
		}
		return innerHTML.join("");
    }
}